<template>

	<div class="bkf7 goods_detail" style="padding-top: 20px;margin-top: 0;">
		<el-container>



			<div class="inter">


				<div class="new_wbox">
					<div class="fl">
						<div class="show_detail">
							<div class="ti_div1">
								<p class="p1">{{goods.title}}</p>
								<p class="p2">
									发布时间:{{goods.publishtime}} &nbsp;&nbsp;
									浏览人数:{{goods.views}}

								</p>
							</div>
							<div class="n_con">
								<div v-html="goods.content">

								</div>
							</div>

						</div>
					</div>
					<div class="fr">
						<div class="div1">
							<p class="wp1">热门游戏</p>
						</div>
						<div class="div1">
							<p class="wp1">最新文章</p>
						</div>
					</div>
				</div>





			</div>

		</el-container>
	</div>

</template>
<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	export default {
		data() {
			return {
				goods: {},
				goods_id: 0,
				loading: true,
				info: {},
				daqu: {},
				baopei: {},
				jiaoyi: {},
				kefu: [],
				qun: [],
				type: 0,
				shouxufei: 0,


			}
		},
		computed: {
			gamelist() {
				return this.$store.getters.gamelist
			},
			config() {
				return this.$store.getters.config
			},
		},
		created: function(data) {

			this.goods_id = this.$route.query.id

			if (this.goods_id == undefined) {
				this.goods_id = this.$route.params.id
			}

			this.getDetail(this.goods_id);


		},
		watch: {
			$route() {

			}
		},
		methods: {


			getDetail(id) {
				var that = this;
				this.rq.requests.post("api/game/hall/ArchivesDetail", {
					id: id,
				}).then(res => {

					that.goods = res.data.archives;
					that.loading = false;

				}).catch(error => {

				})
			},

		}
	}
</script>